var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`CircleImg CircleImg--${_vm.variant}`,style:(_vm.styles),on:{"click":_vm.onClick}},[(_vm.useIconic)?_c('iconic',{staticClass:"CircleImg__img",attrs:{"name":_vm.img}}):_c('img',{staticClass:"CircleImg__img",style:(_vm.stylesImg),attrs:{"src":_vm.img,"alt":_vm.alt}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }